import React from "react";

const ConfigurationContext = React.createContext();

export default ConfigurationContext;